import { createSlice, PayloadAction } from '@reduxjs/toolkit';


export interface ProjectQuoteUiState {
  floorVisibilities: ProjectQuoteFloorVisibility[] | null;
}

export interface ProjectQuoteFloorVisibility {
  floorId: number,
  floorPlanVisible: boolean,
  roomFloorPlansVisible: boolean,
  dropDownOpened: boolean
}

const initialState: ProjectQuoteUiState = {
  floorVisibilities: null
}

export const projectQuoteUiSlice = createSlice({
  name: 'projectQuoteUi',
  initialState,
  reducers: {
    toggleFloorPlanVisible: (state, action: PayloadAction<number>) => {
      let floorVisibility =
          state.floorVisibilities?.find((floorVisibility) => floorVisibility.floorId === action.payload)
      if (floorVisibility) {
        floorVisibility.floorPlanVisible = !floorVisibility.floorPlanVisible;
      } else {
        console.log('toggleFloorPlanVisible called for a floor which isn\'t exist in state.')
      }
    },
    toggleRoomFloorPlansVisible: (state, action: PayloadAction<number>) => {
      let floorVisibility =
          state.floorVisibilities?.find((floorVisibility) => floorVisibility.floorId === action.payload)
      if (floorVisibility) {
        floorVisibility.roomFloorPlansVisible = !floorVisibility.roomFloorPlansVisible;
      } else {
        console.log('toggleRoomFloorPlansVisible called for a floor which isn\'t exist in state.')
      }
    },
    toggleDropdownOpened: (state, action: PayloadAction<number>) => {
      let floorVisibility =
          state.floorVisibilities?.find((floorVisibility) => floorVisibility.floorId === action.payload)
      if (floorVisibility) {
        floorVisibility.dropDownOpened = !floorVisibility.dropDownOpened;
      } else {
        console.log('toggleDropdownOpened called for a floor which isn\'t exist in state.')
      }
    },
    setAllFloors: (state, action: PayloadAction<ProjectQuoteFloorVisibility[]>) => {
      state.floorVisibilities = action.payload;
    },
  },
});

export const {toggleFloorPlanVisible, toggleRoomFloorPlansVisible, toggleDropdownOpened, setAllFloors} = projectQuoteUiSlice.actions
